<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <h1>Meine Läufe</h1>
    <CreateRun @created="createdHandler" :user="$parent.user"/>
    <br>
    <SyncStrava @imported="importHandler" :user="$parent.user"/>
    <br>
    <RunsList @edited="editedHandler"  :forceReload="forceReloadCounter" />
    <br>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import RunsList from '@/components/user/RunsList.vue';
import CreateRun from '@/components/user/CreateRun.vue';
import SyncStrava from '@/components/user/SyncStrava.vue';

export default {
  name: 'Runs',
  components: {
    RunsList,
    CreateRun,
    SyncStrava,
  },
  methods: {
    createdHandler() {
      ++this.forceReloadCounter;
    },
    editedHandler() {
      ++this.forceReloadCounter;
    },
    importHandler() {
        
      ++this.forceReloadCounter;
      
      
    }
  },
  data() {
    return {
      forceReloadCounter: 0
    };
  }
}
</script>
